export default "__VITE_ASSET__82351143__"